import { Dispatch, MutableRefObject, createContext, useContext } from 'react';

import { Action } from './actions';

export type MenuItemDataRef = MutableRefObject<{
  text?: string;
  disabled: boolean;
}>;
type StateMenuItem = { id: string; dataRef: MenuItemDataRef };

export interface MenuState {
  isOpen: boolean;
  buttonRef: MutableRefObject<HTMLButtonElement | null>;
  listRef: MutableRefObject<HTMLDivElement | null>;
  items: StateMenuItem[];
  searchQuery: string;
  activeItemIndex: number;
}

type ContextState = [MenuState, Dispatch<Action>];

export const MenuContext = createContext<ContextState | null>(null);

export function useMenuContext(component: string) {
  const context = useContext(MenuContext);

  if (context === null) {
    throw new Error(`<${component} /> is missing a parent <Menu /> component.`);
  }

  return context;
}
